import VueGtag from 'vue-gtag'
import { loadFonts } from './webfontloader'
import { sentryInit } from '@/plugins/sentry'
import pinia from '../store'
import router from '../router'
import i18n from './i18n'
import flatPickr from 'vue-flatpickr-component'
import { getCurrentEnvironment } from '@/config/firebase'
import { installChunkLoadRecovery } from '@/shared/utils/chunkLoadRecovery'
export function registerPlugins(app) {
  app.config.globalProperties.isDev = getCurrentEnvironment() === 'dev'
  
  // Registrar componente flatPickr globalmente
  app.component('FlatPickr', flatPickr)
  
  loadFonts()
  sentryInit({ app, router })
  installChunkLoadRecovery({ router })
  app
    .use(pinia)
    .use(router)
    .use(i18n)
    .use(VueGtag, {
      appName: 'ISL Project Inscription',
      pageTrackerScreenviewEnabled: true,
      config: {
        id: import.meta.env.VITE_GA_MEASUREMENT_ID,
      },
      router,
    })
}
